/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Pause_While_TypingInputs */

const en_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause While Typing`)
};

const fr_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en pause pendant la saisie`)
};

const de_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause beim Tippen`)
};

const it_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa durante la digitazione`)
};

const ru_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пауза во время набора текста`)
};

const es_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa mientras escribes`)
};

const zh_cn2_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打字时暂停`)
};

const ja_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力中に一時停止する`)
};

const hi_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइप करते समय विराम दें`)
};

const pt_pt2_options_editor_pause_while_typing = /** @type {(inputs: Options_Editor_Pause_While_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça uma pausa enquanto digita.`)
};

/**
* | output |
* | --- |
* | "Pause While Typing" |
*
* @param {Options_Editor_Pause_While_TypingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_pause_while_typing = /** @type {((inputs?: Options_Editor_Pause_While_TypingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Pause_While_TypingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_pause_while_typing(inputs)
	if (locale === "de") return de_options_editor_pause_while_typing(inputs)
	if (locale === "it") return it_options_editor_pause_while_typing(inputs)
	if (locale === "ru") return ru_options_editor_pause_while_typing(inputs)
	if (locale === "es") return es_options_editor_pause_while_typing(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_pause_while_typing(inputs)
	if (locale === "ja") return ja_options_editor_pause_while_typing(inputs)
	if (locale === "hi") return hi_options_editor_pause_while_typing(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_pause_while_typing(inputs)
	return en_options_editor_pause_while_typing(inputs)
});